import { _mock } from "./_mock";

import { DISCOUNT_TYPES } from "src/utils/passticketConstants";
import { _venues } from "./_venues";
import { _trainings } from "./_trainings";
export const types = ["pass", "ticket"];

export const PASSES_NAMES = [
  "Havi korlátlan bérlet",
  "Féléves bérlet",
  "Diákbérlet",
  "Nyugdíjas bérlet",
  "Délelőtti korlátlan",
  "Délutáni korlátlan",
  "Senior bérlet",
  "Versenyző bérlet",
  "VIP bérlet",
];

export const TICKETS_NAMES = [
  "Napi kondijegy",
  "Délutáni jegy 12:00-tól",
  "Szauna belépőjegy",
  "Jeges fürdő jegy",
  "Reggeli jegy",
  "Egész napos diákjegy",
  "Kijárós jegy",
  "VIP jegy",
  "Nyugdíjas jegy",
];

export const PROVIDER_NAMES = [
  "Tigrisek Tenisz Klub",
  "Dunai Fókák SE",
  "Sivatagi Vihar FC",
  "Lövészsport Egyesület",
];

export const FIX_DISCOUNT_VALUES = [1000, 2000, 3000];
export const PERCENT_DISCOUNT_VALUES = [100, 20, 50];

// ----------------------------------------------------------------------
export const _passes = [...Array(4)].map((_, index) => {
  const name = PASSES_NAMES[index];

  const view = index % 3 ? false : true;

  return {
    id: Math.floor(Math.random() * 1000),
    providerName: PROVIDER_NAMES[0],
    name: name,
    salesPeriodStart: _mock.time(index),
    salesPeriodEnd: _mock.time(index + 20),
    credit: 10,
    provider_id: 1,
    scope_type: "exclude",
    scope_venues: "",
    scope_trainings: "",
    onlineorder: 1,
    status: 1,
    discountType: index % 2 == 0 ? DISCOUNT_TYPES[0] : DISCOUNT_TYPES[1],
    discountValue:
      index % 2 == 0
        ? FIX_DISCOUNT_VALUES[Math.floor(Math.random() * 3)]
        : PERCENT_DISCOUNT_VALUES[Math.floor(Math.random() * 3)],
    validity: 31,
    restriction: "",
    timecalculate: "",
    scope: { venues: _venues.slice(0, 2), trainings: _trainings.slice(1, 3) },
    price: 200,
    currency: "HUF",
    description: _mock.description(index),
    view: view,
    type: "pass",
    createdAt: _mock.time(index),
    modifiedAt: _mock.time(index),
  };
});

export const _tickets = [...Array(4)].map((_, index) => {
  const name = TICKETS_NAMES[index];

  const view = index % 3 ? false : true;

  return {
    id: Math.floor(Math.random() * 1000),
    providerName: PROVIDER_NAMES[0],
    name: name,
    validityPeriodStart: _mock.time(index),
    validityPeriodEnd: _mock.time(index + 20),
    price: 350,
    currency: "HUF",
    providerId: 1,
    onlineorder: 1,
    description: _mock.description(index),
    view: view,
    type: "ticket",
    createdAt: _mock.time(index),
    modifiedAt: _mock.time(index),
  };
});
